import { render, staticRenderFns } from "./CommentComposer.vue?vue&type=template&id=a7c55a24&scoped=true&"
import script from "./CommentComposer.vue?vue&type=script&lang=js&"
export * from "./CommentComposer.vue?vue&type=script&lang=js&"
import style0 from "./CommentComposer.vue?vue&type=style&index=0&id=a7c55a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c55a24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7c55a24')) {
      api.createRecord('a7c55a24', component.options)
    } else {
      api.reload('a7c55a24', component.options)
    }
    module.hot.accept("./CommentComposer.vue?vue&type=template&id=a7c55a24&scoped=true&", function () {
      api.rerender('a7c55a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/Comments/CommentComposer.vue"
export default component.exports